import find from "lodash/find";

export class AdvertisementsService {
  constructor($resource, AuthService, ApiService, $cookies) {
    "ngInject";

    this.$cookies = $cookies;
    this.$resource = $resource;
    this.apiService = ApiService;
    this.authService = AuthService;

    //url
    this.advertisementsUrl = this.apiService.getResourceUrl("/advertisements");
    this.createAdvertisementUrl =
      this.apiService.getResourceUrl("/advertisement");
    this.advertisementsWithIdUrl = this.apiService.getResourceUrl(
      "/advertisements/:id"
    );
    this.advertisementPagesListUrl = this.apiService.getResourceUrl(
      "/advertisement/pages"
    );

    //resource
    this.individualResource = this.$resource(this.advertisementsUrl, null);

    this.individualResourceWithId = this.$resource(
      this.advertisementsWithIdUrl,
      null,
      { update: { method: "put" } }
    );

    //create new advertisement
    this.createAdvertisementResource = this.$resource(
      this.createAdvertisementUrl,
      null,
      { create: { method: "post" } }
    );
    //fetch pages list
    this.advertisementPagesListResource = this.$resource(
      this.advertisementPagesListUrl,
      null
    );
  }

  getAdvertisementList(queryParams = {}) {
    const promise = this.individualResource.get(queryParams).$promise;
    return promise
      .then(({ details }) => this.getModifiedList(details))
      .catch((error) => {
        console.log("error", error);
      });
  }

  getModifiedList(details) {
    details.advertisementList = details.advertisementList.map((value) => {
      if (value.fileUuid.desktop) {
        value.imageUrl = this.apiService.getImageUrl(value.fileUuid.desktop);
      } else if (value.fileUuid.tablet) {
        value.imageUrl = this.apiService.getImageUrl(value.fileUuid.tablet);
      } else {
        value.imageUrl = this.apiService.getImageUrl(value.fileUuid.mobile);
      }
      return value;
    });
    return details;
  }

  createAdvertisement(details) {
    const promise = this.createAdvertisementResource.create(details).$promise;
    return promise.then((response) => response);
  }

  updateAdvertisement(details) {
    const promise = this.individualResourceWithId.update(
      { id: details.advertisementId },
      {
        name: details.name,
        link: details.link,
        fileUuid: details.fileUuid,
        advertisementPageId: details.advertisementPageId,
        startDate: details.startDate,
        endDate: details.endDate,
        isActive: details.isActive,
      }
    ).$promise;
    return promise.then((response) => response);
  }

  getAdvertisementPageList() {
    const promise = this.advertisementPagesListResource.get().$promise;
    return promise
      .then(({ details }) => details.advertisementPages)
      .catch((error) => {
        console.log("error", error);
      });
  }

  getAdvertisementsEditDetails(id) {
    const promise = this.individualResourceWithId.get({ id }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        console.log("error", error);
      });
  }

  deleteAdvertisement(id) {
    const promise = this.individualResourceWithId.delete({
      id,
    }).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        console.log("error", error);
      });
  }

  getAdvertisementListByPagination(params) {
    const promise = this.individualResource.get(params).$promise;
    return promise.then(({ details }) => {
      return this.getModifiedList(details);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/advertisements/advertisements.service.js